var _rect, _rect2, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNew12(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.445312,
    y: 0.186279,
    width: 45.1096,
    height: 45.0959,
    rx: 22.5479,
    fill: "#F6F7FB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.445312,
    y: 0.186279,
    width: 45.1096,
    height: 45.0959,
    rx: 22.5479,
    fill: "#19B3B5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M11.774 23.0503C11.774 18.9643 13.97 16.1923 17.336 16.1923C20.702 16.1923 22.916 18.9643 22.916 23.0503C22.916 27.1183 20.828 29.8363 17.336 29.8363C13.844 29.8363 11.774 27.1183 11.774 23.0503ZM14.042 23.0503C14.042 26.0923 15.266 27.8023 17.336 27.8023C19.424 27.8023 20.648 26.0923 20.648 23.0503C20.648 19.9363 19.424 18.2263 17.336 18.2263C15.266 18.2263 14.042 19.9363 14.042 23.0503ZM33.6454 29.5843L24.5194 29.6023V27.8743L28.8214 24.2383C30.6034 22.7263 31.1974 21.8623 31.1974 20.6023C31.1974 19.1083 30.3874 18.2623 29.0014 18.2623C27.5614 18.2623 26.6614 19.2703 26.6434 20.9623H24.3574C24.3754 18.0823 26.2114 16.2103 29.0014 16.2103C31.8094 16.2103 33.5554 17.8123 33.5554 20.4763C33.5554 22.3123 32.5474 23.6983 30.5494 25.4083L28.1734 27.4423H33.6454V29.5843Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4453 23.4736L21.2886 27.261L28.9721 19.6863",
    stroke: "white",
    strokeWidth: 2.1642,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNew12);
export default __webpack_public_path__ + "static/media/new12.7bfb04260f5dbbe84270e5ea72430151.svg";
export { ForwardRef as ReactComponent };